export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70885d76a9d0389de94575915a375788352f268058&name=pushAdClickData!'